<template>
  <div>
    <router-view v-if="access"></router-view>
    <LoadingState v-else></LoadingState>
  </div>
</template>

<script>
import authApi from "./api/auth";
import menuHelper from "./mixins/menu";
import LoadingState from "@/views/Layout/LoadingState";
export default {
  mixins: [menuHelper],
  components: {
    LoadingState
  },
  data() {
    return {
      access: false
    };
  },
  methods: {
    handleImageError(event) {
      // Fallback jika logo tidak ditemukan
      event.target.src = "/favicon.ico";
    }
  },
  async created() {
    if (!document.cookie) {
      this.access = true;
      return;
    }
    const { data } = await authApi.getMe();
    this.access = true;
    if (data.success) {
      // if logged in
      this.$store.state.name = data.data.name;
      this.$store.state.email = data.data.email;
      this.$store.state.no_hp = data.data.no_hp;
      this.$store.state.alamat = data.data.alamat;
      this.$store.state.tokoNow = data.data.toko_id;
      this.$store.state.access_level = data.data.access;
      this.$store.state.jam_masuk = data.data.jam_masuk;
      this.$store.state.jam_pulang = data.data.jam_pulang;
      this.$store.state.hasMember = data.data.hasMember;
      await this.setLocalMenu();
      if (
        window.location.pathname === "/login" ||
        window.location.pathname === "/"
      ) {
        location.href = "/profile";
      }
    } else {
      if (window.location.pathname !== "/login") {
        location.href = "/login";
      }
    }
  }
};
</script>

<style>
.bg-gradient-success {
  background: linear-gradient(87deg, #03989e 0, #2dcecc 100%) !important;
}
</style>
